<template>
    <div class="vue-location-map">
        <GmapMap
            :center="center"
            ref="mapRef"
            :zoom="mapZoom"
            map-type-id="roadmap"
            :options="mapOptions"
            @zoom_changed="mapZoom = $event"
        >
            <gmap-custom-marker
                v-for="(marker, index) in locations"
                :marker="{lat: marker.geo.lat, lng: marker.geo.lng}"
                :key="index"
                class="gmap-custom-marker"
                :class="activeMarker === marker ? 'active' : 'inactive'"
            >
                <aut-marker-wrapper
                    :marker="marker"
                    @marker-clicked="handleSetMapPan"
                    @active-marker="handleActiveMarker"
                    :active-marker="activeMarker"
                    :event-bus="eventBus"
                ></aut-marker-wrapper>
            </gmap-custom-marker>
        </GmapMap>
    </div>
</template>

<script>
import GmapCustomMarker from 'vue2-gmap-custom-marker';
import MarkerWrapper from "./MarkerWrapper";

export default {
    name: "Finder",

    components: {
        'gmap-custom-marker': GmapCustomMarker,
        'aut-marker-wrapper': MarkerWrapper,
    },

    props: {
        locations: {
            type: Array,
        },
        eventBus: {}
    },

    data() {
        return {
            activeMarker: {},
            mapOptions: {
                streetViewControl: false,
                fullscreenControl: false,
            },
            center: {lat: 52.2093661, lng: 5.4205661},
            mapZoom: 8,
        }
    },

    mounted() {
       this.eventBus.$on('set-map-center', (payload) => this.handleSetMapPan(payload));
       this.eventBus.$on('reset-map', () => this.resetMap());
    },

    methods: {
        handleSetMapPan(payload) {
            this.mapZoom = 11;
            this.$refs.mapRef.panTo({lat: parseFloat(payload.lat), lng: parseFloat(payload.lng)})
        },

        handleActiveMarker(payload) {
            this.activeMarker = payload;
        },

        resetMap() {
            this.mapZoom = 8;
            this.$refs.mapRef.panTo(this.center);
        }
    }
}
</script>
